
import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { EUOTActions, GetUOT, AddUOT, GetAllProductTypes, AddProductType, EditProductType } from '../actions/uot.action';
import { map, mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { IAppState } from '../state/app.state';
import { Store } from '@ngrx/store';
import { UOTService } from '../../Services/UOT/uot.service';


@Injectable()
export class UOTEffects {

    getUOT$ = createEffect(() => this.actions$.pipe(
        ofType<GetUOT>(EUOTActions.GetUOT),
        map(action => action),
        mergeMap((payload : any) => this.uotService.getUOT()
        .pipe(map((result: any) => ({ type: '[UOT] Set UOT Details', payload: result })),
          catchError((err) => of({ type: 'Set UOT Error', payload:err, from: 'getUOT' }))
        )
      )
    ));

    addUOT$ = createEffect(() => this.actions$.pipe(
        ofType<AddUOT>(EUOTActions.AddUOT),
        map(action => action.payload),
        mergeMap((payload : any) => this.uotService.addUOT(payload)
        .pipe(map((result: any) => ({ type: 'Set UOT Success', payload: result, from: 'AddUOT' })),
          catchError((err) => of({ type: 'Set UOT Error', payload:err, from: 'AddUOT' }))
        )
      )
    ));

    getProductType$ = createEffect(() => this.actions$.pipe(
        ofType<GetAllProductTypes>(EUOTActions.GetAllProductTypes),
        map(action => action.payload),
        mergeMap((payload : any) => this.uotService.getProductTypes(payload)
        .pipe(map((result: any) => ({ type: '[UOT] Get All Product Types Success', payload: result })),
          catchError((err) => of({ type: '[UOT] Get All Product Types Error', payload:err }))
        )
      )
    ));

    addProductType$ = createEffect(() => this.actions$.pipe(
        ofType<AddProductType>(EUOTActions.AddProductType),
        map(action => action.payload),
        mergeMap((payload : any) => this.uotService.addproductType(payload)
        .pipe(map((result: any) => ({ type: '[UOT] Add Product Type Success', payload: result })),
          catchError((err) => of({ type: '[UOT] Add Product Type Error', payload:err }))
        )
      )
    ));

    editProductType$ = createEffect(() => this.actions$.pipe(
        ofType<EditProductType>(EUOTActions.EditProductType),
        map(action => action.payload),
        mergeMap((payload : any) => this.uotService.editproductType(payload)
        .pipe(map((result: any) => ({ type: '[UOT] Edit Product Type Success', payload: result })),
          catchError((err) => of({ type: '[] Edit Product Type Error', payload:err }))
        )
      )
    ));
    constructor( private actions$: Actions,
        private store: Store<IAppState>,
        private uotService: UOTService
    ){}
}
